import { Badge } from '@/design-system';
import { useColorScheme } from '@/hooks/useColorScheme';

import { getHeatmapStyleFromPercentage } from '../DatasetSessionCompare/components/SingleExperimentColumns/utils/getHeatmapStyleFromPercentage';
import { PERCENT_FORMATTER } from './constants';

export const EvaluatorAlignmentScoreChip = ({
  alignmentScore,
}: {
  alignmentScore: number;
}) => {
  const { isDarkMode } = useColorScheme();
  const { rawColorVar, rawTextColor } = getHeatmapStyleFromPercentage({
    colorMode: isDarkMode ? 'dark' : 'light',
    min: 0,
    max: 1,
    score: alignmentScore,
    isLowerBetter: false,
  });
  return (
    <Badge
      style={{ backgroundColor: rawColorVar, color: rawTextColor }}
      data-testid="alignment-score"
    >
      {PERCENT_FORMATTER.format(alignmentScore)}
    </Badge>
  );
};
